// @flow
import HeaderSearch from 'components/jeChoisisLeRugby/HeaderSearch';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/jeChoisisLeRugby/HeaderSearch';

export default connect((state: StateType): StateProps => ({
  userPref: state.userState.userPref,
  userPrefStatus: state.userState.status
}))(HeaderSearch);
